export const campaignVideo = (() => {
  const campaignVideo = document.getElementById("campaignVideoplayer");
  const button = document.getElementById("campaignVideoButton");
  if (!campaignVideo || !button) return;

  button.addEventListener("click", function () {
    if (campaignVideo.paused) {
      campaignVideo.play();
      button.setAttribute("aria-label", "Pause");
    } else {
      campaignVideo.pause();
      button.setAttribute("aria-label", "Spela");
    }
  });
})();
